// extracted by mini-css-extract-plugin
module.exports = {"root":"GraphQLQueryRow_root__3ERbN","selected":"GraphQLQueryRow_selected__26-v5"};